<div *ngIf="selectedEventTicket$ | async as eventTicket" class="gb-event-ticket-questions-dialog">
  <mat-toolbar role="toolbar" class="gb-dialog-header">
    <h2 translate="EVENT_TICKET.ACCEPT_TICKET.COMPLETE_HEADER" mat-dialog-title></h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-dialog-content>
    <gb-event-ticket-questions-form
      [customFields$]="selectedEventTicketCustomFields$"
      [customValues$]="selectedEventTicketCustomValues$"
      [shouldPrepopulateForm]="true"
      (formReady)="questionsForm = $event"
    ></gb-event-ticket-questions-form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button color="primary" type="submit" (click)="onSubmit()" translate="COMPLETE"></button>
  </mat-dialog-actions>
</div>
